import { Record } from "immutable";
import { Nullable } from "common/types";
export const metaPaginationFromJSON = (json: Partial<IMetaPaginationData>): MetaPaginationRecord => {
  const record: IMetaPaginationRecord = { ...(json as any) };
  return new MetaPaginationRecord(record);
};

export interface IMetaPaginationData {
  current_page: number;
  total_pages: number;
  total_count: number;
  per_page: number;
  next_page: Nullable<number>;
  prev_page: Nullable<number>;
  first_page: boolean;
  last_page: boolean;
}

export interface IMetaPaginationRecord {
  current_page: number;
  total_pages: Nullable<number>;
  total_count: Nullable<number>;
  next_page: Nullable<number>;
  prev_page: Nullable<number>;
  first_page: boolean;
  last_page: boolean;
  per_page: Nullable<number>;
}

const defaultMetaPaginationProps: IMetaPaginationRecord = {
  current_page: 1,
  total_pages: null,
  total_count: null,
  next_page: null,
  prev_page: null,
  first_page: true,
  last_page: true,
  per_page: null,
};

export class MetaPaginationRecord extends Record(defaultMetaPaginationProps) implements IMetaPaginationRecord {}
